import { CalendarClock } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ReturnRequestDateEditorRenderer } from "./editor";
import { ReturnRequestDateEmailRenderer } from "./email";
import type { ReturnRequestDateBlockProps } from "./types";

export default registerBlock<ReturnRequestDateBlockProps>({
  type: "return-request-date",
  name: "editorBlocksLibrary.blocks.return-request-date.title",
  description: "editorBlocksLibrary.blocks.return-request-date.description",
  Icon: CalendarClock,
  category: BlockCategory.RETURN,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnRequestDateEmailRenderer,
      editor: {
        component: ReturnRequestDateEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { ReturnRequestDateBlockProps } from "./types";
